/* Le sélecteur d'offres : choix de la formule, garde-fou sur les tailles,
   et mise au panier.

   Chez la boutique source, une application tierce fait ce travail. Faute de
   l'avoir, on refait son comportement à l'identique :

     · une seule formule active à la fois, la barre choisie prend le liseré ;
     · une taille est cochée d'avance sur chaque menu, et le bouton d'ajout
       n'est JAMAIS grisé : un clic doit suffire. Leur propre garde-fou grise
       le bouton, mais chez eux la barre collante, elle, reste cliquable et
       retombe sur la taille par défaut — c'est ce comportement-là qu'on garde,
       en l'affichant honnêtement plutôt qu'en le cachant ;
     · l'ajout passe par /cart/add.js puis ouvre le tiroir du panier.

   Le prix du kit vient d'une remise automatique « Full Vehicle Kit » (montant
   fixe, à partir de 2 filets), comme chez eux — et non d'un produit « kit ». */
(() => {
  const table = (() => {
    const s = document.getElementById('offres-table');
    try { return s ? JSON.parse(s.textContent) : null; } catch (_) { return null; }
  })();
  const zone = document.querySelector('[data-offres]');
  if (!table || !zone) return;

  const barres = () => [...zone.querySelectorAll('.kaching-bundles__bar')];
  const choisie = () => zone.querySelector('.kaching-bundles__bar--selected');
  const bouton = () => document.querySelector('.atc-button, .product-form__submit');

  /* ── la formule active ─────────────────────────────────────────────── */
  function activer(barre) {
    barres().forEach((b) => {
      const active = b === barre;
      b.classList.toggle('kaching-bundles__bar--selected', active);
      b.querySelector('input[type=radio]').checked = active;
    });
    verrou();
  }

  zone.addEventListener('change', (e) => {
    if (e.target.matches('input[type=radio]')) activer(e.target.closest('.kaching-bundles__bar'));
    if (e.target.matches('.kaching-bundles__bar-variant-select')) {
      e.target.dataset.touchee = '1';
      verrou();
    }
  });
  zone.addEventListener('click', (e) => {
    const main = e.target.closest('.kaching-bundles__bar-main');
    if (main) activer(main.closest('.kaching-bundles__bar'));
  });

  /* ── le garde-fou : pas de taille, pas d'ajout ─────────────────────── */
  function menus() {
    const b = choisie();
    return b ? [...b.querySelectorAll('.kaching-bundles__bar-variant-select')] : [];
  }

  /* Plus de verrou : on coche la première taille de chaque menu et on laisse
     le bouton actif. Un menu resté sur « Select size » bloquait l'ajout sans
     rien dire au visiteur, qui repartait. */
  function verrou() {
    menus().forEach((s) => {
      if (s.selectedIndex <= 0) {
        const premier = [...s.options].findIndex((o) => !o.disabled && o.value && o.value !== '__none__');
        if (premier > 0) s.selectedIndex = premier;
      }
      s.dataset.touchee = '1';
    });
    const btn = bouton();
    if (!btn) return;
    btn.disabled = false;
    btn.style.opacity = '';
    btn.style.cursor = '';
  }

  /* ── la mise au panier ─────────────────────────────────────────────── */
  function articles() {
    const barre = choisie();
    const tailles = menus().map((s) => s.value);
    const items = [];

    /* Un article par taille choisie, toujours le vrai filet — jamais un produit
       « kit ». C'est exactement ce que fait la boutique source : son panier
       contient « Overhead Storage » en quantité 2, et une remise automatique
       « Full Vehicle Kit » de montant fixe ramène la ligne au prix du kit.
       Deux tailles identiques se regroupent d'elles-mêmes en une ligne × 2. */
    tailles.forEach(function (taille) {
      items.push({ id: table.filet[taille], quantity: 1 });
    });
    (table.cadeaux[barre.dataset.dealBarId] || []).forEach(([id, q]) => {
      items.push({ id: id, quantity: q });
    });
    return items;
  }

  function ouvrirLeTiroir(reponse) {
    const tiroir = document.querySelector('cart-drawer');
    if (!tiroir || typeof tiroir.renderContents !== 'function') {
      window.location.href = '/cart';
      return;
    }
    tiroir.classList.remove('is-empty');
    try {
      tiroir.renderContents(reponse);
    } catch (_) {
      window.location.href = '/cart';
    }
  }

  function sections() {
    const tiroir = document.querySelector('cart-drawer');
    if (!tiroir || typeof tiroir.getSectionsToRender !== 'function') return [];
    try { return tiroir.getSectionsToRender().map((s) => s.id); } catch (_) { return []; }
  }

  function ajouter(btn) {
    const items = articles();
    if (!items) return;
    const libelle = btn.innerHTML;
    btn.classList.add('loading');
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: items, sections: sections(), sections_url: window.location.pathname }),
    })
      .then((r) => r.json())
      .then((rep) => {
        if (rep.status) throw new Error(rep.description || rep.message);
        ouvrirLeTiroir(rep);
      })
      .catch(() => { window.location.href = '/cart'; })
      .finally(() => { btn.classList.remove('loading'); btn.innerHTML = libelle; verrou(); });
  }

  /* On intercepte au plus tôt : le formulaire du thème n'ajouterait qu'un
     seul article, sans les cadeaux ni le kit. */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.atc-button, .product-form__submit');
    if (!btn || !zone.isConnected) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!btn.disabled) ajouter(btn);
  }, true);

  /* Chez eux, la formule cochée au chargement est celle au ruban « Most
     Popular » — le kit. C'est ce qui met tout par deux dans leur panier.

     Posée une seule fois au chargement, la sélection se faisait écraser dans la
     seconde qui suit (le thème redessine la colonne produit). On la réaffirme
     donc plusieurs fois, et on s'arrête dès que le visiteur a choisi lui-même :
     sans ce garde-fou, on lui reprendrait son choix des mains. */
  zone.addEventListener('click', () => { zone.dataset.hsChoix = '1'; }, true);
  zone.addEventListener('change', () => { zone.dataset.hsChoix = '1'; }, true);

  function choisirParDefaut() {
    if (zone.dataset.hsChoix) return;
    const populaire = barres().find((b) => b.querySelector('.kaching-bundles__bar-most-popular'));
    if (!populaire || populaire.classList.contains('kaching-bundles__bar--selected')) return;
    activer(populaire);
  }

  choisirParDefaut();
  [100, 400, 900, 1800].forEach((delai) => setTimeout(choisirParDefaut, delai));

  verrou();
})();
